/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="67.29"
        height="92.61"
        viewBox="0 0 67.29 92.61"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M57.19 0H10.12A9.68 9.68 0 0 0 .46 9.66v57.32a9.67 9.67 0 0 0 9.66 9.66h47.07a9.66 9.66 0 0 0 9.67-9.66V9.66A9.67 9.67 0 0 0 57.19 0ZM10.12 2.5h47.07a7.17 7.17 0 0 1 7.16 7.16v57.32a7.16 7.16 0 0 1-7.16 7.16H10.12a7.17 7.17 0 0 1-7.16-7.16V9.66a7.18 7.18 0 0 1 7.16-7.16Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M56.54 15.98H10.77a1.25 1.25 0 0 0-1.25 1.25v26.36a1.25 1.25 0 0 0 1.25 1.25h45.77a1.25 1.25 0 0 0 1.25-1.25V17.23a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v23.86H12.02V18.48Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M24.29 8.1h18.72a1.27 1.27 0 0 1 1.32 1.19 1.25 1.25 0 0 1-1.19 1.31H24.29a1.24 1.24 0 0 1-1.31-1.18 1.25 1.25 0 0 1 1.18-1.32ZM16.39 50.65a6.92 6.92 0 1 0 6.91 6.93 6.92 6.92 0 0 0-6.91-6.93Zm0 2.5a4.42 4.42 0 1 1-4.41 4.43 4.43 4.43 0 0 1 4.41-4.43ZM50.86 50.65a6.92 6.92 0 1 0 6.93 6.91 6.93 6.93 0 0 0-6.93-6.91Zm0 2.5a4.42 4.42 0 1 1-4.41 4.43 4.44 4.44 0 0 1 4.41-4.43Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M17.86 74.69a1.25 1.25 0 0 1 1.77 1.76l-.1.1L2.05 92.29a1.24 1.24 0 0 1-1.76-.09 1.25 1.25 0 0 1 0-1.67l.09-.1ZM47.86 74.88a1.27 1.27 0 0 1 1.65-.17l.11.09 17.24 15.63a1.25 1.25 0 0 1-1.57 1.94l-.1-.08-17.28-15.62a1.24 1.24 0 0 1-.05-1.79Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'SubwayTrainOnTracksIcon';

export default Icon;
